import "./style.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Link, useNavigate } from "react-router-dom";
import { useParams, useNavigate } from "react-router-dom";
import Header from './Header';
// Same origin, like every other screen: nginx proxies /api and /auth to the backend on both
// ports, and an absolute http:// URL is blocked as mixed content the moment the site answers
// on https (2026-09-02). See backendConfig.js.
import { BACKEND_URL } from './backendConfig';
import { useTranslation } from 'react-i18next';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://13.67.118.92:5000";


// `labelKey` is translated where the field is drawn (and where its "required" message is built).
const FORM_FIELDS = [
    { labelKey: "xUsers.f.username", name: "username", type: "text", required: true },
    { labelKey: "xUsers.f.firstNameCap", name: "firstName", type: "text", required: true },
    { labelKey: "xUsers.f.lastNameCap", name: "lastName", type: "text", required: true },
    { labelKey: "xUsers.f.email", name: "email", type: "email", required: true },
    // { label: "Password", name: "password", type: "password", required: true },
    // { label: "Confirm Password", name: "confirmPassword", type: "password", required: true },
];

// keys as the code compares them, names as people read them (the roles table's role_name)
const FALLBACK_ROLES = [{ roleKey: 'User', roleName: 'User' }, { roleKey: 'Admin', roleName: 'Admin' }, { roleKey: 'SOP Team', roleName: 'S.OP Staff' }];

function EditUser() {
    const { t } = useTranslation();
    const { userId } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    const [values, setValues] = useState({
        username: "",
        firstName: "",
        lastName: "",
        email: "",
        role: "User",
        // password: "",
        // confirmPassword: "",
        isActive: false,
        // sendWelcomeEmail: true,
    });

    const [backendError, setBackendError] = useState("");
    const [loading, setLoading] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]);
    const [successMessage, setSuccessMessage] = useState("");
    const [roleOptions, setRoleOptions] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);
    /* Which Sales Rep this account IS — Jay, 2026-09-09: "link the Sales Rep's project with their
       portal account so they can view their project on the welcome page". The rep on a project group
       is a name in a list; this is the only thing joining it to a login. */
    const [salesReps, setSalesReps] = useState([]);
    const [salesRepId, setSalesRepId] = useState('');
    /* WHICH CEO DESK, and it is not a role — Max, 2026-09-23, asking what he has to do when Evonne
       and Sheryl log in. The `ceo_office` grant only says whether the section OPENS; which desk
       somebody is on is Young's rule 2, which is ACCESS and not a filter, and it lives on the
       person rather than in Role & Permissions. Until now it was two lines of SQL. */
    const [ceoDesks, setCeoDesks] = useState([]);
    const toggleRole = (key) => setSelectedRoles((prev) => (prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]));

    // Role dropdown is driven by the roles catalogue (00_PORTAL_roles), not a hardcoded list.
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const res = await axios.get(`${BACKEND_URL}/api/admin/role-options`);
                setRoleOptions(res.data.roles || []); // [{ roleKey, roleName }]
            } catch {
                // the catalogue's names when the server cannot be asked (Jay 02/11: one role, one name — "SOP Team" is "S.OP Staff")
                setRoleOptions(FALLBACK_ROLES);
            }
        };
        fetchRoles();
    }, []);

    useEffect(() => {
        const fetchReps = async () => {
            try {
                const res = await axios.get(`${BACKEND_URL}/api/admin/sales-reps`);
                setSalesReps(res.data.salesReps || []);
            } catch {
                setSalesReps([]);
            }
        };
        fetchReps();
    }, []);

    // useEffect(() => {
    //     const fetchUser = async () => {
    //         try {
    //             const response = await axios.get(`${BACKEND_URL}/profile/${userId}`);
    //             setValues(response.data);
    //         } catch (err) {
    //             setBackendError("Failed to fetch user data.");
    //         }
    //     };
    //     fetchUser();
    // }, [userId]);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                setIsLoading(true);
                const response = await axios.get(`${BACKEND_URL}/user/${userId}`);
                // Transform the backend data to match your form structure
                const userData = {
                    username: response.data.UserName || "",
                    firstName: response.data.UserFirstname || "",
                    lastName: response.data.UserLastname || "",
                    email: response.data.UserEmail || "",
                    role: response.data.UserRole || "User",
                    isActive: response.data.IsActive === 1,
                };
                setValues(userData);
                setSelectedRoles(Array.isArray(response.data.roles) && response.data.roles.length
                    ? response.data.roles
                    : (response.data.UserRole ? [response.data.UserRole] : []));
                setSalesRepId(response.data.salesRepId ? String(response.data.salesRepId) : '');
                setCeoDesks(Array.isArray(response.data.ceoDesks) ? response.data.ceoDesks : []);
            } catch (err) {
                console.error("Error fetching user:", err);
                setBackendError(
                    err.response?.data?.message ||
                    t('xUsers.err.fetchFailedRetry')
                );
            } finally {
                setIsLoading(false);
            }
        };

        if (userId) {
            fetchUser();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setValues((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const validateForm = () => {
        const errors = [];

        // Check required fields
        FORM_FIELDS.forEach((field) => {
            if (field.required && !values[field.name]) {
                errors.push(t('xUsers.err.fieldRequired', { field: t(field.labelKey) }));
            }
        });

        // Validations
        if (values.username && (values.username.length < 3 || values.username.length > 50)) {
            errors.push(t('xUsers.err.usernameLen'));
        }

        if (values.firstName && (values.firstName.length < 2 || values.firstName.length > 50)) {
            errors.push(t('xUsers.err.firstLen'));
        }

        if (values.lastName && (values.lastName.length < 2 || values.lastName.length > 50)) {
            errors.push(t('xUsers.err.lastLen'));
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
            errors.push(t('xUsers.err.emailStar'));
        }

        if (!selectedRoles.length) {
            errors.push(t('xUsers.err.roleStar'));
        }

        // if (values.password.length < 8) {
        //     errors.push("*Password must be at least 8 characters long.");
        // }

        // if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/.test(values.password)) {
        //     errors.push(
        //         "*Password must contain at least one uppercase letter, one lowercase letter, and one number."
        //     );
        // }

        // if (values.password !== values.confirmPassword) {
        //     errors.push("*Passwords do not match.");
        // }

        setValidationErrors(errors);
        return errors.length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);
        setBackendError("");
        setSuccessMessage("");

        try {
            const formData = {
                ...values,
                role: selectedRoles[0] || values.role,
                roles: selectedRoles,
                // Sent as a number or null; the server only touches the link when the field is present.
                salesRepId: salesRepId ? Number(salesRepId) : null,
                // Sent as a list, and the server only touches the desks when the field is present.
                ceoDesks,
                isActive: values.isActive ? 1 : 0,
                userId: userId
            };

            await axios.put(`${BACKEND_URL}/user/${userId}`, formData);

            // alert("Registration successful!");
            setSuccessMessage(t('xUsers.page.updated'));
            // setTimeout(() => {
            //     navigate("/");
            // }, 2000); // Delay for 2 seconds before redirecting
            // Reset the form fields
            setTimeout(() => navigate("/list-user"), 2000);
        } catch (err) {
            if (err.response) {
                if (err.response.status === 400 && err.response.data?.details) {
                    setValidationErrors(err.response.data.details.map((detail) => detail.message));
                } else if (err.response.status === 409) {
                    if (err.response.data.error === "Email already exists") {
                        setBackendError(t('xUsers.err.emailTaken'));
                    } else if (err.response.data.error === "Username already exists") {
                        setBackendError(t('xUsers.err.usernameTaken'));
                    } else {
                        setBackendError(t('xUsers.err.unexpected'));
                    }
                } else {
                    setBackendError(t('xUsers.err.unexpected'));
                }
            } else {
                setBackendError(t('xUsers.err.noServer'));
            }
        } finally {
            setLoading(false);
        }
    };

    if (isLoading) {
        return <div className="loading">{t('xUsers.page.loading')}</div>;
    }

    return (
        <div>
            <Header />
            <div className="content">
                <div className="form-container">
                    <h1 className="form-title">{t('xUsers.page.title')}</h1>
                    <form onSubmit={handleSubmit}>
                        {successMessage && <div className="success-message">{successMessage}</div>}
                        {backendError && <div className="error-message">{backendError}</div>}
                        {validationErrors.length > 0 && (
                            <div className="error-message">
                                {validationErrors.map((error, index) => (
                                    <div key={index}>{error}</div>
                                ))}
                            </div>
                        )}
                    
                        <div className="space-y-4">
                            {FORM_FIELDS.map((field) => (
                                <div key={field.name} className="form-group">
                                    <span className="w-40">{t(field.labelKey)}</span>
                                    <input
                                        type={field.type}
                                        name={field.name}
                                        value={values[field.name]}
                                        onChange={handleChange}
                                        required={field.required}
                                        className="form-field"
                                        placeholder={t(field.labelKey)}
                                    />
                                </div>
                            ))}

                            <div className="form-group">
                                <span className="w-40">{t('xUsers.f.roles')}</span>
                                <div className="form-field" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px 18px' }}>
                                    {(() => {
                                        const opts = roleOptions.length ? roleOptions : FALLBACK_ROLES;
                                        const keys = opts.map((o) => o.roleKey);
                                        // keep any legacy/inactive role the user already has, even if not in the catalogue
                                        const extras = selectedRoles.filter((k) => !keys.includes(k)).map((k) => ({ roleKey: k, roleName: t('xUsers.f.legacyRole', { name: k }) }));
                                        return [...opts, ...extras].map((o) => (
                                            <label key={o.roleKey} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                                                <input type="checkbox" checked={selectedRoles.includes(o.roleKey)} onChange={() => toggleRole(o.roleKey)} className="h-4 w-4" />
                                                {o.roleName}
                                            </label>
                                        ));
                                    })()}
                                </div>
                                </div>

                            {/* One account per rep, both ways: a rep already taken says who has it, and
                                the server refuses the second admin to try. */}
                            <div className="form-group">
                                <span className="w-40">{t('xUsers.f.salesRep')}</span>
                                <div className="form-field">
                                    <select
                                        value={salesRepId}
                                        onChange={(e) => setSalesRepId(e.target.value)}
                                        className="w-full border rounded px-2 py-1"
                                    >
                                        <option value="">{t('xUsers.page.notSalesRep')}</option>
                                        {salesReps.map((r) => (
                                            <option
                                                key={r.salesRepId}
                                                value={r.salesRepId}
                                                disabled={!!r.linkedUserId && String(r.salesRepId) !== salesRepId}
                                            >
                                                {r.linkedUserId && String(r.salesRepId) !== salesRepId
                                                    ? t('xUsers.page.alreadyLinked', { name: r.name, user: r.linkedUser }) : r.name}
                                            </option>
                                        ))}
                                    </select>
                                    {/* A REP WAITING FOR THIS PERSON (Jay task #1174): an unlinked Sales Rep whose name is theirs —
                                        suggested, never linked by itself; Save is the Admin's confirmation */}
                                    {(() => {
                                        const fold = (x) => String(x || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/gi, 'd').toLowerCase().replace(/[^a-z0-9]/g, '');
                                        const keys = new Set([values.firstName, `${values.firstName}${values.lastName}`, `${values.lastName}${values.firstName}`,
                                            values.username, String(values.email || '').split('@')[0]].map(fold).filter((k) => k.length >= 3));
                                        const hit = !salesRepId && salesReps.find((r) => !r.linkedUserId && keys.has(fold(r.name)));
                                        if (!hit) return null;
                                        return (
                                            <p className="eu-repsuggest" data-eu-repsuggest={hit.salesRepId}>
                                                {t('xUsers.page.repSuggest', { name: hit.name })}{' '}
                                                <button type="button" className="eu-repuse" onClick={() => setSalesRepId(String(hit.salesRepId))} data-eu-repuse>
                                                    {t('xUsers.page.repUse', { name: hit.name })}
                                                </button>
                                            </p>
                                        );
                                    })()}
                                    <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0' }}>
                                        {t('xUsers.page.salesRepHint')}
                                    </p>
                                </div>
                            </div>

                            {/* TWO TICKS, NOT A DROPDOWN: a person can be on both desks — Young is
                                — and on neither, which is the safe default and what everybody who
                                does not work in that section should stay on. */}
                            <div className="form-group">
                                <span className="w-40">{t('xUsers.f.ceoDesk')}</span>
                                {/* `.form-field` carries `white-space: nowrap` from style.css — right
                                    for a one-line value, and it made this hint one unbroken line
                                    that pushed the row 173px past the card's right edge. Measured,
                                    not guessed: the field ran to 1444 against a card ending at
                                    1271. The Sales Rep hint above escapes it only by being short
                                    enough to fit. `minWidth: 0` as well, because a flex item will
                                    not shrink below its content without it. */}
                                <div className="form-field w-full"
                                     style={{ whiteSpace: 'normal', minWidth: 0, flex: 1 }}>
                                  <div className="w-full">
                                    {[['business', 'Business'], ['executive', 'Executive']].map(([key, label]) => (
                                        <label key={key} style={{ marginRight: 18, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                            <input
                                                type="checkbox"
                                                checked={ceoDesks.includes(key)}
                                                onChange={(e) => setCeoDesks((prev) => (e.target.checked
                                                    ? [...prev, key] : prev.filter((d) => d !== key)))}
                                            />
                                            {label}
                                        </label>
                                    ))}
                                  </div>
                                    <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0', maxWidth: '100%' }}>
                                        {t('xUsers.page.deskHint')}
                                    </p>
                                </div>
                            </div>

                            <div className="form-group">
                                <span className="w-40">{t('xUsers.f.isActive')}</span>
                                <div className="form-field flex items-center">
                                    <input
                                        type="checkbox"
                                        name="isActive"
                                        checked={values.isActive}
                                        onChange={handleChange}
                                        className="h-4 w-4"
                                    />
                                </div>
                            </div>

                            {/* <div className="form-group">
                                <span className="w-40">Send Welcome Email</span>
                                <div className="form-field flex items-center">
                                    <input
                                        type="checkbox"
                                        name="sendWelcomeEmail"
                                        checked={values.sendWelcomeEmail}
                                        onChange={handleChange}
                                        className="h-4 w-4"
                                    />
                                </div>
                            </div> */}

                            <div className="btn-container">
                                <button
                                    type="submit"
                                    className="btn"
                                    disabled={loading}
                                >
                                    {loading ? t('xUsers.page.updating') : t('xUsers.page.update')}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
    
            <style jsx="true">{`
                .form-container{
                    width:1000px;
                }
                .form-group > span {
                    width: 175px;
                }
                .success-message {
                    color: #28ce00;
                    margin-top: 12px;
                    margin-bottom: 12px;
                    font-size: 14px;
                    text-align:left;
                    width: 100%;
                }
                // Center
            `}</style>
        </div>
    );
}

export default EditUser;